// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"Milestone_milestoneWrapper__go17K","milestoneBackground":"Milestone_milestoneBackground__UQqCm"};